const sessionTokenGenerate = () => {
  return `frnt${(Math.random() + 1).toString(36).substring(3)}`;
}
export default sessionTokenGenerate
